import {AddressType} from 'desktop/types/addressType';

/**
 * delete addressID if address contain this it
 */
export function deleteAddressIDFromAddress(
    shippingAddress: AddressType,
    billingAddress: AddressType,
): {shippingAddress: AddressType; billingAddress: AddressType} {
    const processedAddress = {
        billingAddress: {...billingAddress},
        shippingAddress: {...shippingAddress},
    };
    if (processedAddress.shippingAddress.addressID) {
        delete processedAddress.shippingAddress.addressID;
    }

    if (processedAddress.billingAddress.addressID) {
        delete processedAddress.billingAddress.addressID;
    }
    return processedAddress;
}
